import { flattenDeep } from 'lodash-es'

import extractRawElm from './extract-raw-elm'

export function removeChildren($elm) {
  const elm = extractRawElm($elm)
  let last
  while (!!(last = elm.lastChild)) {
    elm.removeChild(last)
  }
  return $elm
}

export function removeChildrenExcept($elm, ...args) {
  const elm = extractRawElm($elm)
  const except = flattenDeep(args).join(', ')

  for (let index = elm.children.length - 1; index !== -1; index--) {
    const child = elm.children[index]
    if (!child.matches(except)) {
      elm.removeChild(child)
    }
  }

  return $elm
}

export function removeChildrenInclude($elm, ...args) {
  const elm = extractRawElm($elm)
  const include = flattenDeep(args).join(', ')

  for (let index = elm.children.length - 1; index !== -1; index--) {
    const child = elm.children[index]
    if (child.matches(include)) {
      elm.removeChild(child)
    }
  }

  return $elm
}
